import { deathOf } from "./genealogy"

// What is still missing, as one list shared by the table (which filters on it)
// and the chart (which counts it).
//
// It lived in table_view, which meant the only place that knew what a
// half-finished tree was missing was a view you had to go looking for. A member
// transcribing a family document wants a worklist, and the tree is where she
// already is.
//
// `prompt` is the same fact phrased as the thing to DO, for the chart's line.
// The table keeps `label`, which reads as a filter because that is what it is
// there.
export const GAPS = [
    // Somebody the family knows is gone but cannot date. The most useful row in
    // the table, because it is the one question only a relative can answer -
    // which is what the whole shared tree is for.
    { key: "no_death_date", label: "Died, date unknown", prompt: "need a death date", test: (n) => !!n.deceased && !deathOf(n).known },
    { key: "no_birthday", label: "No birthday", prompt: "need a birthday", test: (n) => !n.birth_year_private && !n.birthday && !Number.isFinite(n.birth_year) },
    { key: "no_year", label: "Birthday, no year", prompt: "need a birth year", test: (n) => !!n.birthday && !n.birth_year_known },
    // The year is recorded and the day is not - a partial answer, and the one
    // a relative can usually finish.
    { key: "no_day", label: "Year only, no day", prompt: "need a day and month", test: (n) => n.birth_day_known === false || (!!n.deceased && n.death_day_known === false) },
    // Gender is not cosmetic here: Contacts::RelationLabeler reads it for every
    // label it produces, so a person without it is described as "Grandparent's
    // sibling" where the rest of the family gets "Great-uncle" - the one gap
    // that changes what every OTHER card reads.
    { key: "no_gender", label: "No gender", prompt: "need a gender", test: (n) => !n.gender_private && !n.gender && n.relation !== "You" },
    { key: "unplaced", label: "Not linked to anyone", prompt: "aren't linked to anyone", test: (n, ctx) => !ctx.linked.has(n.id) },
    { key: "no_place", label: "No place", prompt: "need a place", test: (n) => !n.location }
]

// [{ key, label, prompt, count }] for the gaps that actually apply, biggest
// first. Zero-count gaps are dropped: a tree with nothing missing should say
// nothing, not list seven noughts.
export function countGaps(nodes, ctx, { keys = null } = {}) {
    return GAPS
        .filter((gap) => !keys || keys.includes(gap.key))
        .map((gap) => ({ ...gap, count: nodes.filter((node) => gap.test(node, ctx)).length }))
        .filter((gap) => gap.count > 0)
        .sort((a, b) => b.count - a.count)
}
